import type { ReactNode } from 'react';
import { type FieldValues, FormProvider, type UseFormReturn } from 'react-hook-form';

import { Modal, type ModalProps } from './modal';

export type FormModalProps<T extends FieldValues> = Omit<
  ModalProps,
  'onSubmit' | 'primaryText' | 'onPrimary' | 'primaryIsSubmit' | 'children'
> & {
  form: UseFormReturn<T>;
  onSubmit: (values: T) => void | Promise<void>;
  submitText?: string;
  resetOnClose?: boolean;
  children: ReactNode;
};

export function FormModal<T extends FieldValues>({
  form,
  onSubmit,
  submitText = 'Save',
  resetOnClose = true,
  onClose,
  loading,
  maskClosable,
  children,
  ...rest
}: FormModalProps<T>) {
  const isDirty = form.formState.isDirty;
  const handleClose = () => {
    if (resetOnClose) form.reset();
    onClose();
  };

  return (
    <Modal
      {...rest}
      onClose={handleClose}
      maskClosable={maskClosable ?? !isDirty}
      loading={loading || form.formState.isSubmitting}
      primaryText={submitText}
      primaryIsSubmit
      onSubmit={form.handleSubmit(onSubmit)}
    >
      <FormProvider {...form}>{children}</FormProvider>
    </Modal>
  );
}
